import isEmpty from 'lodash/isEmpty';
import { addSoundcastToUser } from './add_soundcast_to_user';

export const setupInitialSoundcast = props => {
  console.log('_SettingNewSoundcast UPDATE', props);
  const { soundcastID, soundcast, checked = 0, sumTotal, userInfo, success = () => {} } = props;
  const hasUser = !isEmpty(userInfo) && userInfo.firstName;
  const hasEmail = !isEmpty(userInfo) && userInfo.email && userInfo.email[0];
  if (hasUser && hasEmail && !isEmpty(soundcast)) {
    console.log(`SettingNewSoundcast executing addSoundcastToUser`);
    let totalPrice = 0;
    if (soundcast.prices && soundcast.prices[checked] && soundcast.prices[checked].price) {
      totalPrice = Number(soundcast.prices[checked].price);
    }

    console.log('addSoundcastToUser', {
      userInfo,
      soundcastID,
      soundcast,
      checked,
      sumTotal,
      totalPrice,
    });

    addSoundcastToUser(
      null, // empty charge
      userInfo,
      soundcastID,
      soundcast,
      checked,
      sumTotal,
      null, // empty coupon
      totalPrice,
      success
    );
  }
};
